export default __webpack_public_path__ + "static/media/close-modal.b1858597.svg";